import { PaginationType } from '@/components/Pagination/schema'
import { atom } from 'jotai'

export const quoteSortByAtom = atom<string>('')
export const quoteSortOrderAtom = atom<string>('')
export const quotePaginationAtom = atom<PaginationType>({
    page: 1,
    pageSize: 5,
})